import { gql } from '@apollo/client'

export const EMAIL_LIST = gql`
    query {
        exportEmailList {
            email
        }
    }
`
